import React from 'react';
import { Modal, Button, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Zone } from '../../pages/YardSpotterApp/yardDataFetch';

interface ZoneEditModalProps {
  open: boolean;
  editingZone: Zone | null;
  onClose: () => void;
  onSave: () => void;
  onZoneChange: (zone: Zone) => void;
}

const ZoneEditModal: React.FC<ZoneEditModalProps> = ({
  open,
  editingZone,
  onClose,
  onSave,
  onZoneChange,
}) => {
  if (!editingZone) return null;

  return (
    <Modal open={open} onClose={onClose}>
      <div className="flex justify-center items-center w-full h-full">
        <div className="w-96 bg-white border p-5 relative">
          <Close
            className="absolute top-4 right-4 cursor-pointer hover:text-slate-400"
            onClick={onClose}
          />
          <h1 className="text-xl font-bold mb-5">Edit Zone</h1>
          
          <div className="space-y-4 mb-5">
            <TextField
              label="Zone Name"
              variant="outlined"
              fullWidth
              value={editingZone.name}
              onChange={(e) => onZoneChange({ ...editingZone, name: e.target.value })}
            />
            
            <div className="flex items-center gap-3">
              <span>Zone Color:</span>
              <input
                type="color"
                value={editingZone.color}
                onChange={(e) => onZoneChange({ ...editingZone, color: e.target.value })}
                className="w-12 h-12 rounded cursor-pointer"
              />
            </div>
          </div>
          
          <div className="flex justify-between pt-3 border-t">
            <Button onClick={onClose}>Cancel</Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={onSave}
              disabled={!editingZone.name.trim()}
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ZoneEditModal;

